import script from "./submit13.vue?vue&type=script&setup=true&lang=js"
export * from "./submit13.vue?vue&type=script&setup=true&lang=js"

import "./submit13.vue?vue&type=style&index=0&id=c3bc38f8&scoped=true&lang=css"

import exportComponent from "D:\\doc\\project\\lunwenzhinengtougaopingtaitest2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3bc38f8"]])

export default __exports__